export default __webpack_public_path__ + "static/media/ChaltenPrototype10.1708a6a8.jpg";